import { useBlockingLoader, useBlockingLoaderVisibility } from 'shared';

// Legacy adapter over shared's blocking loader. The old DataFetch provider's message,
// indicator and sticky arguments were dead in practice (the fullscreen spinner renders with
// hasNoMessage; no call site passes 'local'/'custom'; no call site passed sticky at all),
// so they are accepted and ignored. When you touch a file that calls this hook, migrate the call
// site to useBlockingLoader() from 'shared' (show()/hide() in try/finally) instead.
export default function useDataFetchIndicator(): [
  [boolean],
  (
    isFetching: boolean,
    msg?: string,
    indicator?: 'fullScreen' | 'local' | 'custom',
    isDataFetchingSticky?: boolean,
  ) => void,
] {
  // The two hooks are split so that components that only show/hide the loader don't re-render on
  // every visibility flip. This adapter needs both: it calls the actions and exposes the visibility
  // in its return tuple.
  const blockingLoader = useBlockingLoader();
  const isVisible = useBlockingLoaderVisibility();

  const setDataFetchingInfo = (isFetching: boolean) => {
    if (isFetching) {
      blockingLoader.show();
    } else {
      blockingLoader.hide();
    }
  };

  return [[isVisible], setDataFetchingInfo];
}
